import { render, staticRenderFns } from "./Uncommon.vue?vue&type=template&id=1f01547a&scoped=true"
import script from "./Uncommon.vue?vue&type=script&lang=js"
export * from "./Uncommon.vue?vue&type=script&lang=js"
import style0 from "./Uncommon.vue?vue&type=style&index=0&id=1f01547a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f01547a",
  null
  
)

export default component.exports